import * as React from "react";
import { List, EditButton, Datagrid, TextField, TextInput } from 'react-admin';
import { useTranslate } from 'ra-core';

export const TagGroupList = (props) => {
    const translate = useTranslate();
    const filters = [
        <TextInput label={translate(`cmss.resources.tag-group.fields.name`)} source="name" />,
    ];
    return (
        <List filters={filters} sort={{ field: 'name', order: 'ASC' }} {...props}>
            <Datagrid>
                <TextField source="name" label={translate(`cmss.resources.tag-group.fields.name`)}/>
                <EditButton />
            </Datagrid>
        </List>
    );
}
